<template>
  <VSlideGroup
    ref="slideGroup"
    next-icon="arrow_forward"
    prev-icon="arrow_back"
  >
    <VBreadcrumbs
      ref="baseBreadcrumbs"
      class="px-0 pt-0 pb-2"
      density="compact"
      :items="items"
    >
      <template #title="{ item }">
        <VBtn
          v-if="isLastItem(item)"
          size="small"
          variant="flat"
          class="px-1 bg-neutral-50"
          :to="item.to"
        >
          {{ item.title }}
        </VBtn>
        <VBtnText
          v-else
          class="px-1 text-medium-emphasis text-body-2"
          data-testid="breadcrumbItem"
        >
          {{ item.title }}
        </VBtnText>
      </template>
      <template #divider>
        <div class="h-full d-flex align-center">
          <VIcon
            class="text-medium-emphasis h-full mx-1"
          >
            chevron_right
          </VIcon>
        </div>
      </template>
    </VBreadcrumbs>
  </VSlideGroup>
</template>

<script setup lang="ts">
import { ref, watch, computed } from 'vue';
import type { RouteLocationRaw } from 'vue-router';
import type { VSlideGroup } from 'vuetify/components/VSlideGroup';

export interface BreadCrumbItem {
  title: string;
  disabled?: boolean;
  href?: string;
  to?: RouteLocationRaw;
  onClick?: () => void;
  additionalProperties?: Record<string, any>;
}

export interface Props {
  items: BreadCrumbItem[];
}

const props = defineProps<Props>();

const slideGroup = ref<VSlideGroup | null>(null);
const lastItem = computed(() => props.items[props.items.length - 1]);
const isLastItem = function (item: BreadCrumbItem) {
  return item.title === lastItem.value?.title;
};

watch(
  () => props.items.length,
  async () => {
    await new Promise<void>((resolve) => setTimeout(resolve, 150));
    slideGroup.value?.slide('next');
  },
);
</script>
